import { Component, Input } from '@angular/core';
import { Navigator } from '../menu/navigator';

@Component({
  selector: 'app-redeem-button',
  templateUrl: './redeem-button.component.html',
  styleUrls: ['./redeem-button.component.scss'],
})
export class RedeemButtonComponent  {
  @Input() size = 'large';
  @Input() buttonText = 'Redeem';
  @Input() code: string;
  @Input() type: string;

  constructor(
    public navigator: Navigator,
  ){}

  onRedeemCode() {
    return this.navigator.navigateTo('RedeemBonusCodeComponent', {}, { bonusCode: this.code });
  }
}
